import React, {useEffect, useState} from "react";
import {Card, ListGroup} from "react-bootstrap";
import { NewsItem, Session, User } from "../../types/Types";
import {collection, getDocs, orderBy, query, where} from "@firebase/firestore";
import {db} from "../../../firebase/FirebaseProvider";
import NewsItemRow from "../../hub/NewsItemRow";
import {logDataLoaded} from "../../util/Util";
import { usePagination } from "../../../hooks/usePagination";
import PaginationControls from "../../shared/PaginationControls";

interface Props {
    usersMap: Map<string, User>;
    sessionsMap: Map<string, Session>;
    currentUser: User | undefined;
}

function AdminUpdates(props: Props) {

    const [newsItems, setNewsItems] = useState<Array<NewsItem> | undefined>(undefined);
    const { pageStart, pageEnd, pageLeft, pageRight, getPaginatedItems } = usePagination<NewsItem>({ pageSize: 50 });

    useEffect(() => {
        (async () => {
            await loadAllData();
        })();
    }, [props.currentUser]);

    const loadAllData = async() => {
        let newsItems: Array<NewsItem> = [];
        const newsOnceCollection = query(collection(db, 'news'),
            where('type', '==', 'LOCATION'),
            orderBy('lastModified', 'desc'));
        const newsOnceCollectionSnapshot = await getDocs(newsOnceCollection);
        newsOnceCollectionSnapshot.forEach((doc) => {
            let tempNewsItem = doc.data() as NewsItem;
            newsItems.push(tempNewsItem);
        });
        logDataLoaded('news items', newsItems.length);
        setNewsItems(newsItems);
    }

    const paginatedItems = newsItems ? getPaginatedItems(newsItems) : [];

    return (
        <>
            <Card className={"mb-3"}>
                <ListGroup variant="flush">
                    {!newsItems && <div className={'loading'}>
                        Loading...
                    </div>}
                    {(newsItems && newsItems.length == 0) &&<div className={'loading'}>
                        No updates yet
                    </div>}
                    {paginatedItems.map((newsItem: NewsItem, index: number) => (
                        <NewsItemRow key={newsItem.id} user={props.usersMap.get(newsItem.userId)} newsItem={newsItem} session={props.sessionsMap.get(newsItem.userId)}/>
                    ))}
                </ListGroup>
                {newsItems && newsItems.length > 0 && (
                    <Card.Footer>
                        <PaginationControls
                            pageStart={pageStart}
                            pageEnd={pageEnd}
                            totalItems={newsItems.length}
                            onPageLeft={pageLeft}
                            onPageRight={() => pageRight(newsItems.length)}
                        />
                    </Card.Footer>
                )}
            </Card>
        </>
    )
}

export default AdminUpdates;
